import { post, patch, httpDelete } from 'store/http/httpAction';
import {
  SYNC_FOLDER,
  ADD_FOLDER,
  SET_ACTIVE_FOLDER,
  SET_EDITING_FOLDER,
  RESET_EDITING_FOLDER,
  COMMIT_FOLDER_NAME,
  DELETE_FOLDER,
  DELETE_LOCAL_FOLDER,
  SET_ACTIVE_TAB
} from './actionTypes';

// utils
const getPrefixByType = type => {
  if (['report', 'dashboard'].indexOf(type) < 0) {
    return console.error('No such type of folder!');
  }
  return `/admin/${type}_folder`;
};

export const setActiveFolder = (id, type) => ({
  type: SET_ACTIVE_FOLDER,
  payload: { id, type }
});

export const setEditingFolder = (id, type) => ({
  type: SET_EDITING_FOLDER,
  payload: { id, type }
});

export const resetEditingFolder = (id, type) => ({
  type: RESET_EDITING_FOLDER,
  payload: { id, type }
});

const commitFolderName = (id, type, newName) => ({
  type: COMMIT_FOLDER_NAME,
  payload: { id, type, newName }
});

// NOTES: this is the new name will be saved only when user click save
export const tryCommitFolderName = (id, type, newName) => dispatch =>
  patch(`${getPrefixByType(type)}/${id}`, { name: newName }, dispatch).then(
    data => {
      dispatch(commitFolderName(id, type, newName));
    }
  );

const deleteFolder = (id, type) => ({
  type: DELETE_FOLDER,
  payload: { id, type }
});

export const tryDeleteFolder = (id, type) => dispatch =>
  httpDelete(`${getPrefixByType(type)}/${id}`, {}, dispatch).then(data => {
    if (data.deleted) {
      return dispatch(deleteFolder(id, type));
    }
    console.error(`Fail to delete ${type} folder w/ id ${id}`);
  });

export const addFolder = type => ({
  type: ADD_FOLDER,
  payload: { type }
});

const syncFolder = (type, data) => ({
  type: SYNC_FOLDER,
  payload: { type, data }
});

export const tryCommitNewFolder = (type, newName) => dispatch =>
  post(`${getPrefixByType(type)}/me`, { name: newName }, dispatch).then(
    data => {
      dispatch(setActiveFolder(data.data.id, type));
      dispatch(syncFolder(type, data.data));
    }
  );

/**
 * Delete newly created folder but not yet synced
 * @param {*} type
 */
export const deleteLocalFolder = type => ({
  type: DELETE_LOCAL_FOLDER,
  payload: { type }
});

export const setActiveTab = tab => ({
  type: SET_ACTIVE_TAB,
  payload: { tab }
});



// WEBPACK FOOTER //
// ./src/views/ReportListSider/flow/actions.js